const RadioChecked = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4241_27237)'>
        <path
          d='M8.00065 1.33398C4.32065 1.33398 1.33398 4.32065 1.33398 8.00065C1.33398 11.6807 4.32065 14.6673 8.00065 14.6673C11.6807 14.6673 14.6673 11.6807 14.6673 8.00065C14.6673 4.32065 11.6807 1.33398 8.00065 1.33398ZM8.00065 13.334C5.05398 13.334 2.66732 10.9473 2.66732 8.00065C2.66732 5.05398 5.05398 2.66732 8.00065 2.66732C10.9473 2.66732 13.334 5.05398 13.334 8.00065C13.334 10.9473 10.9473 13.334 8.00065 13.334Z'
          fill='#FEA82F'
        />
        <path
          d='M7.99935 11.3327C9.8403 11.3327 11.3327 9.8403 11.3327 7.99935C11.3327 6.1584 9.8403 4.66602 7.99935 4.66602C6.1584 4.66602 4.66602 6.1584 4.66602 7.99935C4.66602 9.8403 6.1584 11.3327 7.99935 11.3327Z'
          fill='#FEA82F'
        />
      </g>
      <defs>
        <clipPath id='clip0_4241_27237'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RadioChecked;
